const CheckIcon = () => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 5.20154L5 10L14 1.36276L12.59 0L5 7.28407L1.41 3.84837L0 5.20154Z"
      fill="white"
    />
  </svg>
)

export default CheckIcon
